<template>
  <component
    :is="name"
    class="document-icon"
  />
</template>
<script>
import { SvgPdf, SvgDocDocx, SvgJpgPng, SvgDefault,SvgMp3,SvgMp4,SvgOdt,SvgPptOdp,SvgXlsXlsx } from "../assets";
export default {
  components: {
    SvgPdf,
    SvgDocDocx,
    SvgJpgPng,
    SvgDefault,
    SvgMp3,
    SvgMp4,
    SvgOdt,
    SvgPptOdp,
    SvgXlsXlsx,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.document-icon {
  width: 40px;
  height: auto;
}
</style>
